exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryList-module__container--2mrZY {\r\n  width: 100%;\r\n  background-color: #f9f8f8;\r\n  padding: 16px;\r\n  box-sizing: border-box;\r\n  min-height: 352px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "HistoryList-module__container--2mrZY"
};